import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyC_F4LHS6I_5oijt5EWurT5Tjuzga4x-E0",
  authDomain: "gptme-1899f.firebaseapp.com",
  projectId: "gptme-1899f",
  storageBucket: "gptme-1899f.firebasestorage.app",
  messagingSenderId: "121591498833"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app); // Connect to default database (gptandme)
const storage = getStorage(app);
// Analytics disabled to avoid config errors
const analytics = null;

export { auth, db, storage, analytics };
export default app;

